/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { ThemeProvider } from "@emotion/react";
import { Routes, Route } from "react-router-dom";
import { Login, Callback } from "./pages";
import { MemorizedHome } from "./MemorizedHome";
import { theme } from "./theme";
import { SnackbarProvider } from "notistack";
import { FullHeightLoading } from "./App.style";

const App: React.FC = () => {
    const { isLoading } = useAuth0();

    if (isLoading) {
        return (
            // @ts-ignore
            <ThemeProvider theme={theme}>
                <FullHeightLoading />
            </ThemeProvider>
        );
    }

    return (
        // @ts-ignore
        <ThemeProvider theme={theme}>
            {/* @ts-ignore */}
            <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
            >
                <Routes>
                    <Route path="/login" element={Login} />
                    <Route path="/callback" element={<Callback />} />
                    <Route path="/" element={<MemorizedHome />} />
                </Routes>
            </SnackbarProvider>
        </ThemeProvider>
    );
};

export default App;
